import { render, staticRenderFns } from "./exportDia.vue?vue&type=template&id=71b715cc&scoped=true&"
import script from "./exportDia.vue?vue&type=script&lang=js&"
export * from "./exportDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b715cc",
  null
  
)

export default component.exports